export enum UploadProcessRowStatus {
  NEW = 'New',
  UPDATED = 'Updated',
  FAIL = 'Fail',
}
